



























import Vue from 'vue';
import Folder from '../ExplorerView/Folder.vue';
import { axiosApiInstance } from '../../utils/axiosInstances';
import { getLabelsetList } from '../../utils/getFolderList';
import { folderI } from '../../interfaces/folderI';

export default Vue.extend({
  components: {
    Folder,
  },
  props: ['datasetId', 'datasetName'],
  data(): {
    labelsetList: folderI[];
  } {
    return {
      labelsetList: [],
    };
  },
  created() {
    this.$store.commit('startLoading');
    getLabelsetList(this.datasetId).then((labelsetList) => {
      this.labelsetList = labelsetList;
      this.$store.commit('stopLoading');
    });
  },
  methods: {
    onClickDelete(folderInfo: { folderId: string; folderName: string }) {
      axiosApiInstance
        .delete(`/api/v1/labelsets/${folderInfo.folderId}`)
        .then((response) => {
          if (response.status === 200) {
            const newDatasetList = this.labelsetList.filter((labelset: any) => {
              if (labelset.id === folderInfo.folderId) {
                return false;
              }
              return true;
            });

            this.labelsetList = newDatasetList;
          } else {
            alert('라벨셋 삭제에 실패했습니다. 잠시 후에 다시 시도해주세요.');
          }
        })
        .finally(() => {
          this.$store.commit('stopLoading');
        });
    },
  },
});
